/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-organizations" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-organizations" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-organizations" */ `./edit.vue` );
const Duplicates = () => import( /* webpackChunkName: "group-organizations" */ `./duplicates.vue` );
const RedirectedDomains = () => import( /* webpackChunkName: "group-organizations" */ `./redirected-domains.vue` );
const HierarchyReview = () => import( /* webpackChunkName: "group-organizations" */ `./hierarchy-review.vue` );
const MarketReview = () => import( /* webpackChunkName: "group-organizations" */ `./market-review.vue` );
const ContentConnections = () => import( /* webpackChunkName: "group-organizations" */ `./content-connections.vue` );
const CommonWordReview = () => import( /* webpackChunkName: "group-organizations" */ `./common-word-review.vue` );
const WebsiteDomainReview = () => import( /* webpackChunkName: "group-organizations" */ `./website-domain-review.vue` );
const ValidationReview = () => import( /* webpackChunkName: "group-organizations" */ `./validation-review.vue` );
const JunkSenders = () => import( /* webpackChunkName: "group-organizations" */ `./junk-senders.vue` );
const PhraseRules = () => import( /* webpackChunkName: "group-organizations" */ `./phrase-rules.vue` );
const PhraseRuleEditor = () => import( /* webpackChunkName: "group-organizations" */ `./phrase-rule-editor.vue` );
const NewAccounts = () => import( /* webpackChunkName: "group-organizations" */ `./new-accounts.vue` );
const Requests = () => import( /* webpackChunkName: "group-organizations" */ `./requests.vue` );
const HierarchyRequestDetail = () => import( /* webpackChunkName: "group-organizations" */ `./hierarchy-request-detail.vue` );
const ProfileChangeRequestDetail = () => import( /* webpackChunkName: "group-organizations" */ `./profile-change-request-detail.vue` );
const RegistrySuggestionDetail = () => import( /* webpackChunkName: "group-organizations" */ `./registry-suggestion-detail.vue` );
const InboundRequestDetail = () => import( /* webpackChunkName: "group-organizations" */ `./inbound-request-detail.vue` );
const Import = () => import( /* webpackChunkName: "group-organizations" */ `./import.vue` );
const Settings = () => import( /* webpackChunkName: "group-organizations" */ `./settings.vue` );
const DeadListingLinks = () => import( /* webpackChunkName: "group-organizations" */ `./dead-listing-links.vue` );

const ListOrganizationSubscriptions = () => import( /* webpackChunkName: "group-organizations" */ `./subscriptions/list.vue` );
const AddOrganizationSubscription = () => import( /* webpackChunkName: "group-organizations" */ `./subscriptions/add.vue` );
const EditOrganizationSubscription = () => import( /* webpackChunkName: "group-organizations" */ `./subscriptions/edit.vue` );
const OrganizationSubscriptionSettings = () => import( /* webpackChunkName: "group-organizations" */ `./subscriptions/settings.vue` );
const OrganizationSubscriptionSalesReport = () => import( /* webpackChunkName: "group-organizations" */ `./subscriptions/sales-report.vue` );

const AddOrganizationSubscriptionVerticals = () => import( /* webpackChunkName: "group-organizations" */ `./subscriptions/verticals/add.vue` );
const EditOrganizationSubscriptionVerticals = () => import( /* webpackChunkName: "group-organizations" */ `./subscriptions/verticals/edit.vue` );

export default {
	path: `organizations`,
	children: [
		{
			path: ``,
			name: `list-organizations`,
			component: List,
			meta: {
				title: `Organizations`
			}
		},
		{
			path: `duplicates`,
			name: `organization-duplicates`,
			component: Duplicates,
			meta: {
				title: `Duplicate Organizations`
			}
		},
		{
			path: `redirected-domains`,
			name: `organization-redirected-domains`,
			component: RedirectedDomains,
			meta: {
				title: `Redirected Domains`
			}
		},
		{
			path: `hierarchy-review`,
			name: `organization-hierarchy-review`,
			component: HierarchyReview,
			meta: {
				title: `Hierarchy Review`
			}
		},
		{
			path: `market-review`,
			name: `organization-market-review`,
			component: MarketReview,
			meta: {
				title: `Market Review`
			}
		},
		{
			path: `content-connections`,
			name: `organization-content-connections`,
			component: ContentConnections,
			meta: {
				title: `Content Connections`
			}
		},
		{
			path: `website-domain-review`,
			name: `organization-website-domain-review`,
			component: WebsiteDomainReview,
			meta: {
				title: `Website Domain Review`
			}
		},
		{
			path: `validation`,
			name: `organization-validation-review`,
			component: ValidationReview,
			meta: {
				title: `Validation`
			}
		},
		{
			path: `common-word-review`,
			name: `organization-common-word-review`,
			component: CommonWordReview,
			meta: {
				title: `Common Word Names`
			}
		},
		{
			// The unified list behind the module selector's "Requests" tile
			// (module-selector rebuild, 2026-09-14): one browsable, filterable
			// list across the five queue-consolidation types that used to
			// each have their own tile and their own separate list page
			// declared here (or, for the contact@ inbound-email queue,
			// under stringer's own routes) -- all removed by this same
			// change. See requests.vue's own doc comment.
			path: `requests`,
			name: `requests`,
			component: Requests,
			meta: {
				title: `Requests`
			}
		},
		{
			// The New accounts page (wiretap-mono#3365), reached from the admin
			// home tile. No nav entry of its own.
			path: `new-accounts`,
			name: `new-accounts`,
			component: NewAccounts,
			meta: {
				title: `New Accounts`
			}
		},
		{
			// The Requests queue's phrase rules (#2732), reached from the Requests page.
			path: `requests/rules`,
			name: `phrase-rules`,
			component: PhraseRules,
			meta: {
				title: `Phrase rules`
			}
		},
		{
			path: `requests/rules/new`,
			name: `phrase-rule-new`,
			component: PhraseRuleEditor,
			meta: {
				title: `New phrase rule`
			}
		},
		{
			path: `requests/rules/:uuid`,
			name: `phrase-rule-edit`,
			component: PhraseRuleEditor,
			meta: {
				title: `Phrase rule`
			}
		},
		{
			// The junk sender list (#2731): reached from the Requests page.
			path: `requests/junk-senders`,
			name: `junk-senders`,
			component: JunkSenders,
			meta: {
				title: `Junk senders`
			}
		},
		// The read-only Request Queue overview was retired into Requests, which
		// lists every type it did (and decides them). The old URL still lands
		// there.
		{
			path: `request-queue`,
			name: `request-queue`,
			redirect: {
				name: `requests`
			}
		},
		{
			// No nav entry of its own -- reached only via a Request Queue row
			// link, see request-queue.vue and request_queue_api.go's own doc
			// comment on why these two types had no list page to link to.
			path: `hierarchy-requests/:uuid`,
			name: `organization-hierarchy-request-detail`,
			component: HierarchyRequestDetail,
			meta: {
				title: `Hierarchy Request`
			}
		},
		{
			path: `profile-change-requests/:uuid`,
			name: `organization-profile-change-request-detail`,
			component: ProfileChangeRequestDetail,
			meta: {
				title: `Profile Change Request`
			}
		},
		{
			// No nav entry of its own, matching the two detail-only routes
			// above -- reached only via a Request Queue row link.
			path: `registry-suggestions/:uuid`,
			name: `registry-suggestion-detail`,
			component: RegistrySuggestionDetail,
			meta: {
				title: `Registry Suggestion`
			}
		},
		{
			// Queue-consolidation Phase 3 (inbound-request-detail.vue's own
			// doc comment). No nav entry of its own, matching the three
			// detail-only routes above -- reached only via a Request Queue
			// row link, for the five request types whose resolution is a
			// note (listing_request, profile_inquiry, subscription_request,
			// sales_inquiry, contact_request; see request_queue_api.go's own
			// "Phase 3" doc-comment section for why agency_request and
			// di_waitlist_request do not route here).
			path: `inbound-requests/:uuid`,
			name: `inbound-request-detail`,
			component: InboundRequestDetail,
			meta: {
				title: `Request`
			}
		},
		// Retired into the unified Requests page: an agency request is opened
		// on the shared request page and approved or declined there (the grant
		// is the same ResolveAgencyRequest). The old URL still lands on
		// Requests, filtered to agency requests.
		{
			path: `agency-requests`,
			name: `agency-requests`,
			redirect: {
				name: `requests`,
				query: {
					type: `agency_request`
				}
			}
		},
		// Retired into the unified request queue (wiretap-mono#2253
		// follow-up): company suggestions are decided on the request detail
		// page with Approve and Reject. The old URL still lands there.
		{
			path: `suggestions`,
			name: `company-suggestions`,
			redirect: {
				name: `requests`,
				query: {
					type: `organization_suggestion`
				}
			}
		},
		{
			path: `import`,
			name: `organizations-import`,
			component: Import,
			meta: {
				title: `Import Organizations`
			}
		},
		{
			path: `dead-listing-links`,
			name: `organization-dead-listing-links`,
			component: DeadListingLinks,
			meta: {
				title: `Dead Listing Links`
			}
		},
		// Moved to Orders > Professional Services (Matt, 2026-10-25; see
		// professional_services/_routes.js). The old URLs, bookmarks and
		// Slack notices sent before the move still land on the new pages.
		{
			path: `fix-catalog`,
			redirect: {
				name: `professional-services-fix-catalog`
			}
		},
		{
			path: `remediation`,
			redirect: {
				name: `professional-services-remediation`
			}
		},
		{
			path: `remediation/:uuid`,
			redirect: to => ( {
				name: `professional-services-remediation-project`,
				params: {
					uuid: to.params.uuid
				}
			} )
		},
		{
			path: `settings`,
			name: `organization-settings`,
			component: Settings,
			meta: {
				title: `Organization Settings`
			}
		},
		{
			path: `subscriptions`,
			name: `list-organization_subscriptions`,
			component: ListOrganizationSubscriptions,
			meta: {
				title: `Subscriptions`
			}
		},
		{
			path: `subscriptions/new`,
			name: `add-organization_subscription`,
			component: AddOrganizationSubscription,
			meta: {
				title: `Add Organization Subscription`
			}
		},
		{
			path: `subscriptions/settings`,
			name: `organization_subscription-settings`,
			component: OrganizationSubscriptionSettings,
			meta: {
				title: `Organization Subscription Settings`
			}
		},
		{
			path: `subscriptions/sales_report`,
			name: `organization_subscription-sales-report`,
			component: OrganizationSubscriptionSalesReport,
			meta: {
				title: `Sales Report`
			}
		},
		{
			path: `subscriptions/:uuid`,
			name: `edit-organization_subscription`,
			component: EditOrganizationSubscription,
			meta: {
				title: `Edit Organization Subscription`
			}
		},
		{
			path: `subscriptions/:subscription_uuid/verticals/new`,
			name: `add-organization_subscription_vertical`,
			component: AddOrganizationSubscriptionVerticals,
			meta: {
				title: `Add Organization Subscription Vertical`
			}
		},
		{
			path: `subscriptions/:subscription_uuid/verticals/:uuid`,
			name: `edit-organization_subscription_vertical`,
			component: EditOrganizationSubscriptionVerticals,
			meta: {
				title: `Edit Organization Subscription Vertical`
			}
		},
		{
			path: `new`,
			name: `add-organization`,
			component: Add,
			meta: {
				title: `Add Organization`
			}
		},
		{
			path: `:uuid`,
			name: `edit-organization`,
			component: Edit,
			meta: {
				title: `Edit Organization`
			}
		}
	]
};
